/*
 * Keeps the product price block in sync with the purchase option chosen in the
 * Recharge subscription widget: Subscribe & Save shows the selected selling
 * plan's price, One-Time shows the variant's unit price.
 *
 * Recharge owns the pricing. window.SubscriptionWidgetConfig.formattedPrices
 * holds, per variant, the unit price plus a price for every selling plan, so we
 * read those figures rather than recalculating discounts here. That keeps the
 * displayed price from ever drifting away from what Recharge charges.
 *
 * Recharge assigns the hidden selling_plan input programmatically, which fires
 * no change event, so we re-read after interaction and also watch the form.
 */
;(function () {
  if (window.__purchaseOptionPriceInit) return
  window.__purchaseOptionPriceInit = true

  var PRICE_SELECTOR = '[data-purchase-option-price]'
  var FORM_SELECTOR = 'form[action*="/cart/add"]'
  // The widget updates asynchronously after a click, so re-read a few times.
  var SETTLE_DELAYS = [0, 150, 400]

  function formatMoney(cents, format) {
    var value = cents / 100
    if (!format) return value.toFixed(2)

    function withSeparators(decimals, thousands, decimalMark) {
      var fixed = value.toFixed(decimals)
      var parts = fixed.split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands)
      return parts.length > 1 ? parts.join(decimalMark) : parts[0]
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
      switch (name) {
        case 'amount':
          return withSeparators(2, ',', '.')
        case 'amount_no_decimals':
          return withSeparators(0, ',', '.')
        case 'amount_with_comma_separator':
          return withSeparators(2, '.', ',')
        case 'amount_no_decimals_with_comma_separator':
          return withSeparators(0, '.', ',')
        case 'amount_with_apostrophe_separator':
          return withSeparators(2, "'", '.')
        default:
          return withSeparators(2, ',', '.')
      }
    })
  }

  // The page carries several product forms (upsells, bundles), so stay inside
  // the section that owns this price block.
  function findForm(priceEl) {
    var scope = priceEl.closest('.shopify-section')
    var form = scope && scope.querySelector(FORM_SELECTOR)
    if (form) return form

    var planInput = document.querySelector(FORM_SELECTOR + ' [name="selling_plan"]')
    return planInput ? planInput.closest('form') : null
  }

  function variantEntry(form) {
    var config = window.SubscriptionWidgetConfig
    var prices = config && config.formattedPrices
    if (!prices) return null

    var variantInput = form.querySelector('[name="id"]')
    var variantId = variantInput && variantInput.value
    return (variantId && prices[variantId]) || null
  }

  // One-time price. Every selling plan entry records the variant's own price,
  // so prefer that integer over parsing the formatted "unit" string.
  function unitPriceCents(entry) {
    var plans = entry.sellingPlans || {}
    for (var id in plans) {
      if (typeof plans[id].variantPrice === 'number') return plans[id].variantPrice
    }

    var parsed = parseFloat(String(entry.unit || '').replace(/[^\d.]/g, ''))
    return isNaN(parsed) ? null : Math.round(parsed * 100)
  }

  function selectedPriceCents(form) {
    var entry = variantEntry(form)
    if (!entry) return null

    var planInput = form.querySelector('[name="selling_plan"]')
    var planId = planInput && planInput.value
    var plan = planId && entry.sellingPlans && entry.sellingPlans[planId]

    if (plan && typeof plan.planPrice === 'number') return plan.planPrice
    return unitPriceCents(entry)
  }

  function render(priceEl) {
    var form = findForm(priceEl)
    if (!form) return

    var cents = selectedPriceCents(form)
    // Recharge missing or still loading: leave the Liquid-rendered price alone.
    if (cents === null) return

    var money = formatMoney(cents, priceEl.getAttribute('data-money-format'))
    var items = priceEl.querySelectorAll('.price-item--regular, .price-item--sale')

    Array.prototype.forEach.call(items, function (item) {
      // Leave the compare-at strikethrough untouched.
      if (item.closest('.price__compare')) return
      if (item.textContent.trim() !== money) item.textContent = money
    })
  }

  function renderAll() {
    var blocks = document.querySelectorAll(PRICE_SELECTOR)
    Array.prototype.forEach.call(blocks, render)
  }

  function scheduleRender() {
    SETTLE_DELAYS.forEach(function (delay) {
      setTimeout(renderAll, delay)
    })
  }

  function observeForms() {
    if (typeof MutationObserver !== 'function') return

    var blocks = document.querySelectorAll(PRICE_SELECTOR)
    Array.prototype.forEach.call(blocks, function (priceEl) {
      var form = findForm(priceEl)
      if (!form || form.__purchaseOptionObserved) return
      form.__purchaseOptionObserved = true

      new MutationObserver(scheduleRender).observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value'],
      })
    })
  }

  function init() {
    renderAll()
    observeForms()
    // Catch the widget's own async setup on first paint.
    scheduleRender()
  }

  document.addEventListener('change', scheduleRender)
  document.addEventListener('click', scheduleRender)
  document.addEventListener('shopify:section:load', init)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
